import { IInvoice } from './Invoice'
import * as React from "react";

export interface IInvoiceTableProperties {
    tableName: string;
    columns: IColumnDefinition[];
    invoiceGroup: string;
    subComponentColumns: IColumnDefinition[];
    showPagination: boolean;
    showApproveButton: boolean;
    showApproveAllButton: boolean;
    dataUrl: string;
    filterable: boolean;
    filterBy: string;
    title: string;
    pivotBy?: string[];
    tableId: number;
    ignoreText: string;
    keyField: string;
}

export class InvoiceTableProperties implements IInvoiceTableProperties {
    tableName: string;
    columns: IColumnDefinition[];
    invoiceGroup: string;
    subComponentColumns: IColumnDefinition[];
    showPagination: boolean;
    showApproveButton: boolean;
    showApproveAllButton: boolean;
    dataUrl: string;
    filterable: boolean;
    filterBy: string;
    title: string;
    pivotBy?: string[];
    tableId: number;
    ignoreText: string;
    keyField: string;
}


export interface InvoiceTableState {
    loading: boolean;
    page: number;
    pageSize: number;
    totalPages: number;
    sorted: string;
    data: IInvoice[];
    originalData: IInvoice[];
    selection: string[];
    selectAll: boolean;
    filterOptions: string[];
    showConfirmationModal: boolean;
    pivotBy: string[];
    canFetchNewData: boolean;
    approveCount: number;
    invoiceSearch: string;
}

export interface IColumnDefinition {
    Header?: string;
    id?: string;
    accessor: any;
    Cell?: any;
    className?: string;
    sortable?: boolean;
    aggregate?: any;
    Aggregated?: any;
    resizable: boolean;
    minWidth?: number;
}
